import React, { useState } from "react";
import { format, parse, isValid } from "date-fns";
import { CalendarIcon } from "lucide-react";
import { cn } from "@/lib/utils";
import { Button } from "@/components/ui/button";
import { Calendar } from "@/components/ui/calendar";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/components/ui/popover";

export function DatePicker({ value, onChange, placeholder, className, ...props }) {
  const [open, setOpen] = useState(false);

  // Parse value string (YYYY-MM-DD) to Date
  const dateValue = value ? parse(value, "yyyy-MM-dd", new Date()) : undefined;
  const isDateValid = dateValue && isValid(dateValue);

  const handleSelect = (date) => {
    if (date) {
      onChange(format(date, "yyyy-MM-dd"));
    }
    setOpen(false);
  };

  return (
    <Popover open={open} onOpenChange={setOpen} modal={true}>
      <PopoverTrigger asChild>
        <Button
          variant="outline"
          type="button"
          className={cn(
            "w-full justify-start text-left font-normal h-9",
            !isDateValid && "text-slate-400",
            className
          )}
          data-testid={props["data-testid"]}
        >
          <CalendarIcon className="mr-2 h-4 w-4 text-slate-400" />
          {isDateValid ? (
            <span className="text-slate-700">{format(dateValue, "dd MMM yyyy")}</span>
          ) : (
            <span>{placeholder || "Pick a date"}</span>
          )}
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-auto p-0 z-[100]" align="start">
        <Calendar
          mode="single"
          selected={isDateValid ? dateValue : undefined}
          onSelect={handleSelect}
          defaultMonth={isDateValid ? dateValue : new Date()}
          initialFocus
        />
      </PopoverContent>
    </Popover>
  );
}
